import {ScrollingContent} from "./../html/scrollingContent";

import {FormatInt, FormatPercent} from "../functions/fnFormat";

import * as d3Selection from 'd3-selection'
import * as d3Dispatch from 'd3-dispatch'
import * as d3Array from 'd3-array'
import * as d3Fetch from 'd3-fetch'
import * as d3Dsv from 'd3-dsv'
const d3=Object.assign({},d3Selection,d3Dispatch,d3Array,d3Fetch,d3Dsv);




class Results extends ScrollingContent {

    /**
     * CONSTRUCTEUR
     * @param {String}          id                   Identifiant
     */
    constructor(numTour) {
        super('Resultats');
        this.numTour = numTour || 1;
    }

    update(datum){
        this.id=datum.idcirco;
        this.tour=datum.tour;
        this._metadata=this._data.get('listeCircos').find('CIRCO_ID',this.id);
        this.empty();
        this._load(datum.tour);
        return this;
    }

    _title(){
        let title=[],
            circo = (this._metadata['CIRCO_NOM']===1) ? '1<sup>ère</sup>' : `${this._metadata['CIRCO_NOM']}<sup>e</sup>`;
        if (this._metadata['DEP_NOM']) title.push(this._metadata['DEP_NOM'].toUpperCase());
        title.push(circo+ ' circonscription');
        this._header = this.innerContainer.append('header');
        this._header.append('h3').text(this._metadata['REG_NOM']);
        this._header.append('h4').html(title.join(' / '));
        return this;
    }

    _load(tour=2){
        this.enqueue( () => new Promise((resolve,reject) => {
            let fileName=`assets/data/circonscriptions/t${tour}_${this.id.replace('-','')}.csv`;
            try{
                d3.csv(fileName).then((dataset) => {
                        this.data('circo', dataset.map(d3.autoType).sort((a,b)=> b.voix-a.voix ));
                        resolve(this);
                    });
            }catch(error){
                this.data('circo',null);
                console.warn(error);
                resolve(this);
            }
        }));
    }

    render(delay=0){
        delay = (!this._style.opacity)? delay : 0;
        setTimeout(()=>{
            this.enqueue( () => new Promise((resolve) => {
                this._title();
                let mentions=this._data.get('circo')[0],
                    inscrits=mentions.inscrits,
                    votants=mentions.votants,
                    exprimes=mentions.exprimes,
                    participation=100 * votants/inscrits;
                //this._container.append('p').text(`Participation : ${FormatPercent(participation)}`);
                let title=(this.tour===1)?"Résultats du 1<sup>er</sup> tour":"Résultats du 2<sup>e</sup> tour";
                const   table = this.innerContainer.append('table'),
                       // summary= table.append('thead'),
                        figs = new Map();
                table.append('caption').html(title);
                figs.set('inscrits', { });
                figs.set('votants', { bold:true, className:'participation' });
                figs.set('blancs', { });
                figs.set('nuls', { });
                figs.set('exprimes', { label: 'Exprimés' });
                for (const [key, value] of figs){
                    let tr =  table.append('tr'),
                        td0 = value.label || key.charAt(0).toUpperCase() + key.slice(1),
                        td1 = FormatInt (mentions[key]),
                        td2 = FormatPercent(100 * mentions[key]/inscrits );
                    tr.append('td').text(td0).attr('colspan','2').style('padding-left','1.2rem');
                    tr.append('td').text(td1).classed('right',true);
                    tr.append('td').text(td2).classed('bold',value.bold).classed('right',true);
                    tr.append('td').text('').attr('colspan',2).classed(value.className,value.className);
                }
                this.innerContainer.select('td.participation').html('&nbsp;&nbsp;&nbsp;PARTICIPATION').classed('bold',true);
               // table.append('tr').append('td').attr('colspan','6').classed('separator',true);
                const tbody=table.append('tbody');
                tbody.append('tr').attr('class','separator').append('td').attr('colspan','6');
                tbody.append('tr').attr('class','colNames').html('<th colspan="2" rowspan="2"></th><th rowspan="2" style="vertical-align: bottom;">voix</th><th colspan="2" style="text-align: center;">&nbsp;&nbsp;Pourcentage</th><th rowspan="2"></th>');
                tbody.append('tr').attr('class','colNames').html('<th>inscrits</th><th>exprimés</th>');
                tbody.append('tr').attr('class','separator').append('td').attr('colspan','6');
                if (this.tour===1){
                    let ballotage=true;
                    this._data.get('circo').forEach( (d,i)=>{
                        let tr = tbody.append('tr').attr('class','cand'),
                            color = (this._data.get('listeNuances').has(d.nuance))? this._data.get('listeNuances').get(d.nuance)[0].couleur : '#ccc',
                            td0A = `<span style="background-color:${color};"></span>`,
                            td0B = `${d.nom} ${d.prenom} (${d.nuance})`,
                            td1 = FormatInt (d.voix),
                            td2 = FormatPercent(d.pct_inscrits),
                            td3 = FormatPercent(d.pct_exprimes),
                            td4 = (d.elu==='O')? 'élu(e)': (d.elu==='B')? 'ball.' :'';
                        let td5='';
                        if (d.pct_exprimes>50 && d.pct_inscrits>25) {
                            td5='élu(e)';
                            ballotage=false;
                        }
                        else if (i<2 && ballotage) td5='ball.'
                        else if (d.pct_inscrits>12.5 && ballotage) td5='ball.';

                        if (td5!=='') tr.classed('bold',true);
                        tr.append('td').html(td0A).attr('class','color');
                        tr.append('td').text(td0B);
                        tr.append('td').text(td1).classed('right',true);
                        tr.append('td').text(td2).classed('right',true);
                        tr.append('td').text(td3).classed('right',true);
                        tr.append('td').text(td5).classed('right',true);

                    });
                    let oldState = true;
                    tbody.selectAll("tr.cand").each((d,i,n)=>{
                        let state = (n[i].classList.contains('bold'));
                        if (state != oldState && i>0) d3.select(n[i-1]).selectAll('td').style('padding-bottom','2vh');
                        oldState=state;
                    })}

                    else{
                        this._data.get('circo').forEach( (d,i)=>{
                            let tr = tbody.append('tr').attr('class','cand'),
                                color = (this._data.get('listeNuances').has(d.nuance))? this._data.get('listeNuances').get(d.nuance)[0].couleur : '#ccc',
                                td0A = `<span style="background-color:${color};"></span>`,
                                td0B = `${d.nom} ${d.prenom} (${d.nuance})`,
                                td1 = FormatInt (d.voix),
                                td2 = FormatPercent(d.pct_inscrits),
                                td3 = FormatPercent(d.pct_exprimes),
                                td4 = (d.elu==='O')? 'élu(e)': '';
                            let td5='';
                            tr.append('td').html(td0A).attr('class','color');
                            tr.append('td').text(td0B);
                            tr.append('td').text(td1).classed('right',true);
                            tr.append('td').text(td2).classed('right',true);
                            tr.append('td').text(td3).classed('right',true);
                            tr.append('td').text(td4).classed('right',true);
                            if (d.elu==='O') tr.classed('bold',true).selectAll('td').style('padding-bottom','2vh');
                    });
                }

                this.show();
                resolve(this);
            }))
        },delay);
    }

    show(){
        d3.select('div._Panel').style('display','none');
        this._parent.container
            .style('pointer-events','auto')
            .transition().duration(500)
                .style('background','rgba(255,255,255,.9)');
        this.fadeIn();
        this.innerContainer.on('click',()=> this.hide() );
    }

    hide(){
        d3.select('div._Panel').style('display','block');
        this._parent.container
            .style('pointer-events','none')
            .transition().duration(500)
                .style('background','none');
        this.fadeOut();
        this.empty();
        this.innerContainer.on('click',null);
    }


}

export {Results}
